<template>
	<v-autocomplete
		ref="comboAutoComplete"
		v-model="selected"
		:name="name"
		:items="items"
		dense
		:filter="filtroCampoAutoComplete"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="slotData">
			<slot :name="scopedSlotName" v-bind="slotData"></slot>
		</template>
		<template v-for="(_, slotName) in $slots" #[slotName]>
			<slot :name="slotName"></slot>
		</template>
		<template #item="{ item, on, attrs }">
			<div v-bind="attrs" v-on="on" class="v-list-item">
				<div class="v-list-item__content" :style="obterLarguraAutoComplete('comboAutoComplete')">
					<slot v-bind="{ item }" name="itemText">
						<div class="d-flex align-center ma-0">
							<v-tooltip :disabled="!exibirTooltip" top>
								<template #activator="{ on }">
									<v-checkbox v-if="exibirCheckBox" v-model="attrs.inputValue" v-on="on"></v-checkbox>
									<span v-on="on">{{ item[$attrs['item-text']] }}</span>
								</template>
								<span>{{ item.nome }}</span>
							</v-tooltip>
						</div>
					</slot>
				</div>
			</div>
		</template>
		<template #append>
			<slot name="appendIcon"></slot>
		</template>
	</v-autocomplete>
</template>

<script>

export default {
	name: 'combo-autocomplete',
	inject: ['$validator'],
	props: {
		name: {
			type: String,
			required: true,
		},
		value: {
			type: [String, Number, Array, Object],
			default: null,
		},
		items: {
			type: Array,
			required: true,
		},
		exibirCheckBox: {
			type: Boolean,
		},
		setItemQuantidadeUm: {
			type: Boolean,
			default: true,
		},
		exibirTooltip: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		selected: {
			get() {
				return this.value
			},
			set(newValue) {
				this.$emit('input', newValue)
			},
		},
	},
	watch: {
    items(newValue, oldValue) {
      if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
        this.verificarQuantidadeItensSelecionaveis()
      }
    },
  },
	created() {
		if (this.selected === null) {
			this.verificarQuantidadeItensSelecionaveis()
		}
	},
	methods: {
		filtroCampoAutoComplete(item, queryText) {
			if (this.$attrs['filter']) {
				return this.$attrs['filter'](item, queryText)
			}

			const text = item[this.$attrs['item-text']].toLowerCase()
			const searchText = queryText.toLowerCase()
			return text.indexOf(searchText) > -1
		},
		obterLarguraAutoComplete(ref) {
			if (this.$refs[ref] && this.$refs[ref].$el) {
				return {
					width: this.$refs[ref].$el.clientWidth - 30 + 'px',
				}
			}
			return {}
		},
		verificarQuantidadeItensSelecionaveis() {
			if (this.items.length === 1 && this.setItemQuantidadeUm) {
				this.$emit('input', this.items[0][this.$attrs['item-value']])
			}
		},
	},
}
</script>
<style scoped>
::v-deep .v-select__selections input {
	max-height: 100% !important;
}
</style>
